export const CountryList = [
  {
    name: 'Afghanistan',
    value: 'AFG',
    iso2: 'AF',
  },
  {
    name: 'Åland Islands',
    value: 'ALA',
    iso2: 'AX',
  },
  {
    name: 'Albania',
    value: 'ALB',
    iso2: 'AL',
  },
  {
    name: 'Algeria',
    value: 'DZA',
    iso2: 'DZ',
  },
  {
    name: 'American Samoa',
    value: 'ASM',
    iso2: 'AS',
  },
  {
    name: 'Andorra',
    value: 'AND',
    iso2: 'AD',
  },
  {
    name: 'Angola',
    value: 'AGO',
    iso2: 'AO',
  },
  {
    name: 'Anguilla',
    value: 'AIA',
    iso2: 'AI',
  },
  {
    name: 'Antarctica',
    value: 'ATA',
    iso2: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    value: 'ATG',
    iso2: 'AG',
  },
  {
    name: 'Argentina',
    value: 'ARG',
    iso2: 'AR',
  },
  {
    name: 'Armenia',
    value: 'ARM',
    iso2: 'AM',
  },
  {
    name: 'Aruba',
    value: 'ABW',
    iso2: 'AW',
  },
  {
    name: 'Australia',
    value: 'AUS',
    iso2: 'AU',
  },
  {
    name: 'Austria',
    value: 'AUT',
    iso2: 'AT',
  },
  {
    name: 'Azerbaijan',
    value: 'AZE',
    iso2: 'AZ',
  },
  {
    name: 'Bahamas (the)',
    value: 'BHS',
    iso2: 'BS',
  },
  {
    name: 'Bahrain',
    value: 'BHR',
    iso2: 'BH',
  },
  {
    name: 'Bangladesh',
    value: 'BGD',
    iso2: 'BD',
  },
  {
    name: 'Barbados',
    value: 'BRB',
    iso2: 'BB',
  },
  {
    name: 'Belarus',
    value: 'BLR',
    iso2: 'BY',
  },
  {
    name: 'Belgium',
    value: 'BEL',
    iso2: 'BE',
  },
  {
    name: 'Belize',
    value: 'BLZ',
    iso2: 'BZ',
  },
  {
    name: 'Benin',
    value: 'BEN',
    iso2: 'BJ',
  },
  {
    name: 'Bermuda',
    value: 'BMU',
    iso2: 'BM',
  },
  {
    name: 'Bhutan',
    value: 'BTN',
    iso2: 'BT',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    value: 'BOL',
    iso2: 'BO',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    value: 'BES',
    iso2: 'BQ',
  },
  {
    name: 'Bosnia and Herzegovina',
    value: 'BIH',
    iso2: 'BA',
  },
  {
    name: 'Botswana',
    value: 'BWA',
    iso2: 'BW',
  },
  {
    name: 'Bouvet Island',
    value: 'BVT',
    iso2: 'BV',
  },
  {
    name: 'Brazil',
    value: 'BRA',
    iso2: 'BR',
  },
  {
    name: 'British Indian Ocean Territory (the)',
    value: 'IOT',
    iso2: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    value: 'BRN',
    iso2: 'BN',
  },
  {
    name: 'Bulgaria',
    value: 'BGR',
    iso2: 'BG',
  },
  {
    name: 'Burkina Faso',
    value: 'BFA',
    iso2: 'BF',
  },
  {
    name: 'Burundi',
    value: 'BDI',
    iso2: 'BI',
  },
  {
    name: 'Cabo Verde',
    value: 'CPV',
    iso2: 'CV',
  },
  {
    name: 'Cambodia',
    value: 'KHM',
    iso2: 'KH',
  },
  {
    name: 'Cameroon',
    value: 'CMR',
    iso2: 'CM',
  },
  {
    name: 'Canada',
    value: 'CAN',
    iso2: 'CA',
  },
  {
    name: 'Cayman Islands (the)',
    value: 'CYM',
    iso2: 'KY',
  },
  {
    name: 'Central African Republic (the)',
    value: 'CAF',
    iso2: 'CF',
  },
  {
    name: 'Chad',
    value: 'TCD',
    iso2: 'TD',
  },
  {
    name: 'Chile',
    value: 'CHL',
    iso2: 'CL',
  },
  {
    name: 'China',
    value: 'CHN',
    iso2: 'CN',
  },
  {
    name: 'Christmas Island',
    value: 'CXR',
    iso2: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands (the)',
    value: 'CCK',
    iso2: 'CC',
  },
  {
    name: 'Colombia',
    value: 'COL',
    iso2: 'CO',
  },
  {
    name: 'Comoros (the)',
    value: 'COM',
    iso2: 'KM',
  },
  {
    name: 'Congo (the Democratic Republic of the)',
    value: 'COD',
    iso2: 'CD',
  },
  {
    name: 'Congo (the)',
    value: 'COG',
    iso2: 'CG',
  },
  {
    name: 'Cook Islands (the)',
    value: 'COK',
    iso2: 'CK',
  },
  {
    name: 'Costa Rica',
    value: 'CRI',
    iso2: 'CR',
  },
  {
    name: "Côte d'Ivoire",
    value: 'CIV',
    iso2: 'CI',
  },
  {
    name: 'Croatia',
    value: 'HRV',
    iso2: 'HR',
  },
  {
    name: 'Cuba',
    value: 'CUB',
    iso2: 'CU',
  },
  {
    name: 'Curaçao',
    value: 'CUW',
    iso2: 'CW',
  },
  {
    name: 'Cyprus',
    value: 'CYP',
    iso2: 'CY',
  },
  {
    name: 'Czechia',
    value: 'CZE',
    iso2: 'CZ',
  },
  {
    name: 'Denmark',
    value: 'DNK',
    iso2: 'DK',
  },
  {
    name: 'Djibouti',
    value: 'DJI',
    iso2: 'DJ',
  },
  {
    name: 'Dominica',
    value: 'DMA',
    iso2: 'DM',
  },
  {
    name: 'Dominican Republic (the)',
    value: 'DOM',
    iso2: 'DO',
  },
  {
    name: 'Ecuador',
    value: 'ECU',
    iso2: 'EC',
  },
  {
    name: 'Egypt',
    value: 'EGY',
    iso2: 'EG',
  },
  {
    name: 'El Salvador',
    value: 'SLV',
    iso2: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    value: 'GNQ',
    iso2: 'GQ',
  },
  {
    name: 'Eritrea',
    value: 'ERI',
    iso2: 'ER',
  },
  {
    name: 'Estonia',
    value: 'EST',
    iso2: 'EE',
  },
  {
    name: 'Eswatini',
    value: 'SWZ',
    iso2: 'SZ',
  },
  {
    name: 'Ethiopia',
    value: 'ETH',
    iso2: 'ET',
  },
  {
    name: 'Falkland Islands (the) [Malvinas]',
    value: 'FLK',
    iso2: 'FK',
  },
  {
    name: 'Faroe Islands (the)',
    value: 'FRO',
    iso2: 'FO',
  },
  {
    name: 'Fiji',
    value: 'FJI',
    iso2: 'FJ',
  },
  {
    name: 'Finland',
    value: 'FIN',
    iso2: 'FI',
  },
  {
    name: 'France',
    value: 'FRA',
    iso2: 'FR',
  },
  {
    name: 'French Guiana',
    value: 'GUF',
    iso2: 'GF',
  },
  {
    name: 'French Polynesia',
    value: 'PYF',
    iso2: 'PF',
  },
  {
    name: 'French Southern Territories (the)',
    value: 'ATF',
    iso2: 'TF',
  },
  {
    name: 'Gabon',
    value: 'GAB',
    iso2: 'GA',
  },
  {
    name: 'Gambia (the)',
    value: 'GMB',
    iso2: 'GM',
  },
  {
    name: 'Georgia',
    value: 'GEO',
    iso2: 'GE',
  },
  {
    name: 'Germany',
    value: 'DEU',
    iso2: 'DE',
  },
  {
    name: 'Ghana',
    value: 'GHA',
    iso2: 'GH',
  },
  {
    name: 'Gibraltar',
    value: 'GIB',
    iso2: 'GI',
  },
  {
    name: 'Greece',
    value: 'GRC',
    iso2: 'GR',
  },
  {
    name: 'Greenland',
    value: 'GRL',
    iso2: 'GL',
  },
  {
    name: 'Grenada',
    value: 'GRD',
    iso2: 'GD',
  },
  {
    name: 'Guadeloupe',
    value: 'GLP',
    iso2: 'GP',
  },
  {
    name: 'Guam',
    value: 'GUM',
    iso2: 'GU',
  },
  {
    name: 'Guatemala',
    value: 'GTM',
    iso2: 'GT',
  },
  {
    name: 'Guernsey',
    value: 'GGY',
    iso2: 'GG',
  },
  {
    name: 'Guinea',
    value: 'GIN',
    iso2: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    value: 'GNB',
    iso2: 'GW',
  },
  {
    name: 'Guyana',
    value: 'GUY',
    iso2: 'GY',
  },
  {
    name: 'Haiti',
    value: 'HTI',
    iso2: 'HT',
  },
  {
    name: 'Heard Island and McDonald Islands',
    value: 'HMD',
    iso2: 'HM',
  },
  {
    name: 'Holy See (the)',
    value: 'VAT',
    iso2: 'VA',
  },
  {
    name: 'Honduras',
    value: 'HND',
    iso2: 'HN',
  },
  {
    name: 'Hong Kong',
    value: 'HKG',
    iso2: 'HK',
  },
  {
    name: 'Hungary',
    value: 'HUN',
    iso2: 'HU',
  },
  {
    name: 'Iceland',
    value: 'ISL',
    iso2: 'IS',
  },
  {
    name: 'India',
    value: 'IND',
    iso2: 'IN',
  },
  {
    name: 'Indonesia',
    value: 'IDN',
    iso2: 'ID',
  },
  {
    name: 'Iran (Islamic Republic of)',
    value: 'IRN',
    iso2: 'IR',
  },
  {
    name: 'Iraq',
    value: 'IRQ',
    iso2: 'IQ',
  },
  {
    name: 'Ireland',
    value: 'IRL',
    iso2: 'IE',
  },
  {
    name: 'Isle of Man',
    value: 'IMN',
    iso2: 'IM',
  },
  {
    name: 'Israel',
    value: 'ISR',
    iso2: 'IL',
  },
  {
    name: 'Italy',
    value: 'ITA',
    iso2: 'IT',
  },
  {
    name: 'Jamaica',
    value: 'JAM',
    iso2: 'JM',
  },
  {
    name: 'Japan',
    value: 'JPN',
    iso2: 'JP',
  },
  {
    name: 'Jersey',
    value: 'JEY',
    iso2: 'JE',
  },
  {
    name: 'Jordan',
    value: 'JOR',
    iso2: 'JO',
  },
  {
    name: 'Kazakhstan',
    value: 'KAZ',
    iso2: 'KZ',
  },
  {
    name: 'Kenya',
    value: 'KEN',
    iso2: 'KE',
  },
  {
    name: 'Kiribati',
    value: 'KIR',
    iso2: 'KI',
  },
  {
    name: "Korea (the Democratic People's Republic of)",
    value: 'PRK',
    iso2: 'KP',
  },
  {
    name: 'Korea (the Republic of)',
    value: 'KOR',
    iso2: 'KR',
  },
  {
    name: 'Kuwait',
    value: 'KWT',
    iso2: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    value: 'KGZ',
    iso2: 'KG',
  },
  {
    name: "Lao People's Democratic Republic (the)",
    value: 'LAO',
    iso2: 'LA',
  },
  {
    name: 'Latvia',
    value: 'LVA',
    iso2: 'LV',
  },
  {
    name: 'Lebanon',
    value: 'LBN',
    iso2: 'LB',
  },
  {
    name: 'Lesotho',
    value: 'LSO',
    iso2: 'LS',
  },
  {
    name: 'Liberia',
    value: 'LBR',
    iso2: 'LR',
  },
  {
    name: 'Libya',
    value: 'LBY',
    iso2: 'LY',
  },
  {
    name: 'Liechtenstein',
    value: 'LIE',
    iso2: 'LI',
  },
  {
    name: 'Lithuania',
    value: 'LTU',
    iso2: 'LT',
  },
  {
    name: 'Luxembourg',
    value: 'LUX',
    iso2: 'LU',
  },
  {
    name: 'Macao',
    value: 'MAC',
    iso2: 'MO',
  },
  {
    name: 'Republic of North Macedonia',
    value: 'MKD',
    iso2: 'MK',
  },
  {
    name: 'Madagascar',
    value: 'MDG',
    iso2: 'MG',
  },
  {
    name: 'Malawi',
    value: 'MWI',
    iso2: 'MW',
  },
  {
    name: 'Malaysia',
    value: 'MYS',
    iso2: 'MY',
  },
  {
    name: 'Maldives',
    value: 'MDV',
    iso2: 'MV',
  },
  {
    name: 'Mali',
    value: 'MLI',
    iso2: 'ML',
  },
  {
    name: 'Malta',
    value: 'MLT',
    iso2: 'MT',
  },
  {
    name: 'Marshall Islands (the)',
    value: 'MHL',
    iso2: 'MH',
  },
  {
    name: 'Martinique',
    value: 'MTQ',
    iso2: 'MQ',
  },
  {
    name: 'Mauritania',
    value: 'MRT',
    iso2: 'MR',
  },
  {
    name: 'Mauritius',
    value: 'MUS',
    iso2: 'MU',
  },
  {
    name: 'Mayotte',
    value: 'MYT',
    iso2: 'YT',
  },
  {
    name: 'Mexico',
    value: 'MEX',
    iso2: 'MX',
  },
  {
    name: 'Micronesia (Federated States of)',
    value: 'FSM',
    iso2: 'FM',
  },
  {
    name: 'Moldova (the Republic of)',
    value: 'MDA',
    iso2: 'MD',
  },
  {
    name: 'Monaco',
    value: 'MCO',
    iso2: 'MC',
  },
  {
    name: 'Mongolia',
    value: 'MNG',
    iso2: 'MN',
  },
  {
    name: 'Montenegro',
    value: 'MNE',
    iso2: 'ME',
  },
  {
    name: 'Montserrat',
    value: 'MSR',
    iso2: 'MS',
  },
  {
    name: 'Morocco',
    value: 'MAR',
    iso2: 'MA',
  },
  {
    name: 'Mozambique',
    value: 'MOZ',
    iso2: 'MZ',
  },
  {
    name: 'Myanmar',
    value: 'MMR',
    iso2: 'MM',
  },
  {
    name: 'Namibia',
    value: 'NAM',
    iso2: 'NA',
  },
  {
    name: 'Nauru',
    value: 'NRU',
    iso2: 'NR',
  },
  {
    name: 'Nepal',
    value: 'NPL',
    iso2: 'NP',
  },
  {
    name: 'Netherlands (the)',
    value: 'NLD',
    iso2: 'NL',
  },
  {
    name: 'New Caledonia',
    value: 'NCL',
    iso2: 'NC',
  },
  {
    name: 'New Zealand',
    value: 'NZL',
    iso2: 'NZ',
  },
  {
    name: 'Nicaragua',
    value: 'NIC',
    iso2: 'NI',
  },
  {
    name: 'Niger (the)',
    value: 'NER',
    iso2: 'NE',
  },
  {
    name: 'Nigeria',
    value: 'NGA',
    iso2: 'NG',
  },
  {
    name: 'Niue',
    value: 'NIU',
    iso2: 'NU',
  },
  {
    name: 'Norfolk Island',
    value: 'NFK',
    iso2: 'NF',
  },
  {
    name: 'Northern Mariana Islands (the)',
    value: 'MNP',
    iso2: 'MP',
  },
  {
    name: 'Norway',
    value: 'NOR',
    iso2: 'NO',
  },
  {
    name: 'Oman',
    value: 'OMN',
    iso2: 'OM',
  },
  {
    name: 'Pakistan',
    value: 'PAK',
    iso2: 'PK',
  },
  {
    name: 'Palau',
    value: 'PLW',
    iso2: 'PW',
  },
  {
    name: 'Palestine, State of',
    value: 'PSE',
    iso2: 'PS',
  },
  {
    name: 'Panama',
    value: 'PAN',
    iso2: 'PA',
  },
  {
    name: 'Papua New Guinea',
    value: 'PNG',
    iso2: 'PG',
  },
  {
    name: 'Paraguay',
    value: 'PRY',
    iso2: 'PY',
  },
  {
    name: 'Peru',
    value: 'PER',
    iso2: 'PE',
  },
  {
    name: 'Philippines (the)',
    value: 'PHL',
    iso2: 'PH',
  },
  {
    name: 'Pitcairn',
    value: 'PCN',
    iso2: 'PN',
  },
  {
    name: 'Poland',
    value: 'POL',
    iso2: 'PL',
  },
  {
    name: 'Portugal',
    value: 'PRT',
    iso2: 'PT',
  },
  {
    name: 'Puerto Rico',
    value: 'PRI',
    iso2: 'PR',
  },
  {
    name: 'Qatar',
    value: 'QAT',
    iso2: 'QA',
  },
  {
    name: 'Réunion',
    value: 'REU',
    iso2: 'RE',
  },
  {
    name: 'Romania',
    value: 'ROU',
    iso2: 'RO',
  },
  {
    name: 'Russian Federation (the)',
    value: 'RUS',
    iso2: 'RU',
  },
  {
    name: 'Rwanda',
    value: 'RWA',
    iso2: 'RW',
  },
  {
    name: 'Saint Barthélemy',
    value: 'BLM',
    iso2: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'SHN',
    iso2: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    value: 'KNA',
    iso2: 'KN',
  },
  {
    name: 'Saint Lucia',
    value: 'LCA',
    iso2: 'LC',
  },
  {
    name: 'Saint Martin (French part)',
    value: 'MAF',
    iso2: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    value: 'SPM',
    iso2: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    value: 'VCT',
    iso2: 'VC',
  },
  {
    name: 'Samoa',
    value: 'WSM',
    iso2: 'WS',
  },
  {
    name: 'San Marino',
    value: 'SMR',
    iso2: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    value: 'STP',
    iso2: 'ST',
  },
  {
    name: 'Saudi Arabia',
    value: 'SAU',
    iso2: 'SA',
  },
  {
    name: 'Senegal',
    value: 'SEN',
    iso2: 'SN',
  },
  {
    name: 'Serbia',
    value: 'SRB',
    iso2: 'RS',
  },
  {
    name: 'Seychelles',
    value: 'SYC',
    iso2: 'SC',
  },
  {
    name: 'Sierra Leone',
    value: 'SLE',
    iso2: 'SL',
  },
  {
    name: 'Singapore',
    value: 'SGP',
    iso2: 'SG',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    value: 'SXM',
    iso2: 'SX',
  },
  {
    name: 'Slovakia',
    value: 'SVK',
    iso2: 'SK',
  },
  {
    name: 'Slovenia',
    value: 'SVN',
    iso2: 'SI',
  },
  {
    name: 'Solomon Islands',
    value: 'SLB',
    iso2: 'SB',
  },
  {
    name: 'Somalia',
    value: 'SOM',
    iso2: 'SO',
  },
  {
    name: 'South Africa',
    value: 'ZAF',
    iso2: 'ZA',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    value: 'SGS',
    iso2: 'GS',
  },
  {
    name: 'South Sudan',
    value: 'SSD',
    iso2: 'SS',
  },
  {
    name: 'Spain',
    value: 'ESP',
    iso2: 'ES',
  },
  {
    name: 'Sri Lanka',
    value: 'LKA',
    iso2: 'LK',
  },
  {
    name: 'Sudan (the)',
    value: 'SDN',
    iso2: 'SD',
  },
  {
    name: 'Suriname',
    value: 'SUR',
    iso2: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    value: 'SJM',
    iso2: 'SJ',
  },
  {
    name: 'Sweden',
    value: 'SWE',
    iso2: 'SE',
  },
  {
    name: 'Switzerland',
    value: 'CHE',
    iso2: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    value: 'SYR',
    iso2: 'SY',
  },
  {
    name: 'Taiwan (Province of China)',
    value: 'TWN',
    iso2: 'TW',
  },
  {
    name: 'Tajikistan',
    value: 'TJK',
    iso2: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of',
    value: 'TZA',
    iso2: 'TZ',
  },
  {
    name: 'Thailand',
    value: 'THA',
    iso2: 'TH',
  },
  {
    name: 'Timor-Leste',
    value: 'TLS',
    iso2: 'TL',
  },
  {
    name: 'Togo',
    value: 'TGO',
    iso2: 'TG',
  },
  {
    name: 'Tokelau',
    value: 'TKL',
    iso2: 'TK',
  },
  {
    name: 'Tonga',
    value: 'TON',
    iso2: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    value: 'TTO',
    iso2: 'TT',
  },
  {
    name: 'Tunisia',
    value: 'TUN',
    iso2: 'TN',
  },
  {
    name: 'Turkey',
    value: 'TUR',
    iso2: 'TR',
  },
  {
    name: 'Turkmenistan',
    value: 'TKM',
    iso2: 'TM',
  },
  {
    name: 'Turks and Caicos Islands (the)',
    value: 'TCA',
    iso2: 'TC',
  },
  {
    name: 'Tuvalu',
    value: 'TUV',
    iso2: 'TV',
  },
  {
    name: 'Uganda',
    value: 'UGA',
    iso2: 'UG',
  },
  {
    name: 'Ukraine',
    value: 'UKR',
    iso2: 'UA',
  },
  {
    name: 'United Arab Emirates (the)',
    value: 'ARE',
    iso2: 'AE',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland (the)',
    value: 'GBR',
    iso2: 'GB',
  },
  {
    name: 'United States Minor Outlying Islands (the)',
    value: 'UMI',
    iso2: 'UM',
  },
  {
    name: 'United States of America (the)',
    value: 'USA',
    iso2: 'US',
  },
  {
    name: 'Uruguay',
    value: 'URY',
    iso2: 'UY',
  },
  {
    name: 'Uzbekistan',
    value: 'UZB',
    iso2: 'UZ',
  },
  {
    name: 'Vanuatu',
    value: 'VUT',
    iso2: 'VU',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    value: 'VEN',
    iso2: 'VE',
  },
  {
    name: 'Viet Nam',
    value: 'VNM',
    iso2: 'VN',
  },
  {
    name: 'Virgin Islands (British)',
    value: 'VGB',
    iso2: 'VG',
  },
  {
    name: 'Virgin Islands (U.S.)',
    value: 'VIR',
    iso2: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    value: 'WLF',
    iso2: 'WF',
  },
  {
    name: 'Western Sahara',
    value: 'ESH',
    iso2: 'EH',
  },
  {
    name: 'Yemen',
    value: 'YEM',
    iso2: 'YE',
  },
  {
    name: 'Zambia',
    value: 'ZMB',
    iso2: 'ZM',
  },
  {
    name: 'Zimbabwe',
    value: 'ZWE',
    iso2: 'ZW',
  },
]
